
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import {User as Storeuser} from '@/store/index'
import OrgForm from './OrgForm.vue'
import LicenceForm from './LicenceForm.vue'
import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '../Atomic/CardTitle.vue'
import { Organisation } from '@/models/organisation'

import OrganisationsService from '../../services/OrganisationsService'
import {INotificationService} from '../../services/NotificationService'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import {OrganisationJobTitle} from '@/models/organisationJobTitle'
import JobTitlesForm from '@/components/Extras/JobTitlesForm.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
    OrgForm,
    JobTitlesForm,
    LicenceForm,
    ProgressLinear,
  },
})

export default class CreateOrganisation extends Vue {
@State public readonly user: Storeuser
@Prop() public readonly orgs!: Organisation[]
@Prop() public readonly org!: Organisation
@Prop() public readonly jobTitles!: OrganisationJobTitle[]
@Prop() public readonly licences!: string[]
@Prop(Function) public readonly onDialogClose!: () => void
private isPending: boolean = false
private dialog: boolean = false

private errorHandlerService: ErrorHandlerService
private $notificationService!: INotificationService
private stepNumber: number = 1

constructor() {
  super()
  this.errorHandlerService = new ErrorHandlerService()
}

private mounted() {
}

private async update() {
  this.isPending = true
  const validated = await this.$validator.validateAll()
  if (validated) {
    try {
      await OrganisationsService.update(this.org, this.org.id)
      this.$notificationService.success(this.$t('EXTRAS.OrganisationUpdated').toString())
      this.onDialogClose()
      this.dialog = false
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
  }
  this.isPending = false
}

  private async next() {
    const validated = await this.$validator.validateAll()
    if (validated) {
      this.stepNumber++
    }
  }

  private previous() {
    this.stepNumber = 1
  }
  private resetDialog() {
    this.stepNumber = 1
    this.dialog = false
  }

}
